"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _ga = require("@/utils/ga");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _survey = require("@/api/survey");
var _index = _interopRequireDefault(require("../../components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SurveyList',
  components: {
    SearchBox: _index.default
  },
  filters: {
    getInternalTitle(value) {
      // console.log('row value', value)
      return typeof value === 'undefined' ? '' : value.title;
    }
  },
  data() {
    return {
      // search
      trainingStatus: _lifehikesInitData.trainingStatus,
      types: ['learning-passport', 'manager720' /*, 'hike', 'loop', 'vilt', 'other'*/],
      query: {
        page: 1,
        limit: 50,
        q: undefined,
        publish: undefined,
        type: undefined
      },
      // table
      tableLoading: false,
      surveyList: [],
      total: 0,
      // drawer
      copyDrawer: false,
      checked: {
        drawTitle: '',
        id: '',
        type: true,
        category: true,
        title: true,
        description: true,
        accessMethod: true,
        accessKey: true,
        iconImg: true,
        iconDisableImg: true,
        backgroundColor: true,
        timesTake: true,
        pages: true
        // equations: true,
        // belongToHike: true,
        // mailList: true,
      }
    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    sort(data) {
      const {
        prop,
        order
      } = data;
      if (prop === 'title') {
        order === 'ascending' ? this.query.sort = '+title' : this.query.sort = '-title';
      }
      if (prop === 'publish') {
        order === 'ascending' ? this.query.sort = '+publish' : this.query.sort = '-publish';
      }
      if (prop === 'createdAt') {
        order === 'ascending' ? this.query.sort = '+createdAt' : this.query.sort = '-createdAt';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.query.sort = '+updatedAt' : this.query.sort = '-updatedAt';
      }
      this.search(1);
    },
    search(pageNo) {
      this.query.page = pageNo;
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      this.query.publish = this.query.publish === '' ? undefined : this.query.publish;
      this.query.type = this.query.type === '' ? undefined : this.query.type;
      this.getList();
    },
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _log.showDebugLog)('Survey query', this.query);
      (0, _survey.getSurveyList)(token, this.query).then(response => {
        (0, _log.showDebugLog)('Survey-Search-response', response);
        this.surveyList = response.data.rows;
        this.total = response.data.count;
        this.tableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('Survey-Search-error', error);
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
      });
    },
    handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    // copy
    openDrawer(id, title) {
      this.copyDrawer = true;
      this.checked.drawTitle = `Copy a New Survey from [${title} (${id})]`;
      this.checked.id = id;
    },
    handleDrawClose(done) {
      this.$confirm('Are you sure you want to stop copy?').then(_ => {
        done();
      }).catch(_ => {});
    },
    copy() {
      const link = `/survey/createfromcopy?` + `fromId=${this.checked.id}&` + `type=${this.checked.type}&` + `c=${this.checked.category}&` + `t=${this.checked.title}&` + `d=${this.checked.description}&` + `am=${this.checked.accessMethod}&` + `ak=${this.checked.accessKey}&` + `ii=${this.checked.iconImg}&` + `idi=${this.checked.iconDisableImg}&` + `bc=${this.checked.backgroundColor}&` + `tt=${this.checked.timesTake}&` + `p=${this.checked.pages}`;
      this.$router.push(link);
    },
    // delete
    deleteSurvey(id, title) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      this.$confirm(`This will delete [ ${title} ]. Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        // var data = { publish: 'markdelete' }
        // updateHikeById(token, id, data).then(response => {
        //   this.search(this.query.page)
        //   const msg = 'Survey is deleted'
        //   displayPopupMessage(msg, 'success')
        //   writeGaEvent(this, 'Hike', `${userEvent.survey.delete}`, oEmail, `Survey Id: ${id}`)
        // }).catch((error) => {
        //   displayPopupMessage(error, 'error')
        // })
        (0, _survey.deleteSurveyById)(token, id).then(response => {
          this.search(this.query.page);
          const msg = 'Survey is deleted';
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(this, 'Hike', `${_lifehikesInitData.userEvent.survey.delete}`, oEmail, `Survey Id: ${id}`);
        }).catch(error => {
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }).catch(() => {
        const msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    disableVisble(id) {
      this.$refs[id].visible = false;
    }
  }
};